<template>
  <div :class="{'index-steps': true, 'index-steps-animate': animate}">
    <div class="aircraft-box">
      <img
        class="aircraft-img"
        :src="aircraftIcon"
      />
    </div>

    <div class="steps-box">
      <div class="line">
        <div class="progress"></div>
      </div>
      <div
        class="content"
        id="idexStepsContent"
      >
        <div
          :class="['steps', `steps-active-${index}`]"
          v-for="(item, index) in stepList"
          :key="index"
        >
          <div class="num">{{ (index+1).toString().length > 1 ? (index+1) : ('0' + (index+1)) }}</div>
          <div class="img">
            <img
              class="done-icon"
              :src="stepSuccessIcon"
            />
          </div>
          <p class="title-text">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import aircraftIcon from '@/assets/newPromotionImg/aircraft.png'
    import stepSuccessIcon from '@/assets/newPromotionImg/step_success.png'
    export default {
        data(){
            return {
                stepSuccessIcon,
                aircraftIcon,
                currentStep: 0,
                stepList: [
                    {
                        title: "领取试读体验课",
                    },
                    {
                        title: "预约排课",
                    },
                    {
                        title: "正式试读体验",
                    },
                ],
                animate: false,
            }
        },
        mounted(){
            const target = document.querySelector("#idexStepsContent");
            const callback = (entries, observer)=>{
                if (entries[0].isIntersecting) {
                    this.animate = true;
                    return;
                }

                this.animate = false;
            };
            const options = {};
            const observer = new IntersectionObserver(callback, options);
            observer.observe(target);
        }
    }
</script>

<style lang="scss" scoped>
   .index-steps {
    .aircraft-box {
        width: 100%;
        height: 42px;
        position: relative;
        transition: all 0.35s;
        // animation: aircraft-box-animate 6s ease-in 0s infinite;

        .aircraft-img {
            position: absolute;
            top: -3px;
            left: 0;
            width: 59px;
            height: 42px;
            transform: translateX(-50%);
            margin-bottom: 4px;

            // animation: aircraft-animate 6s ease-in 0s 1 forwards;
        }
    }

    .steps-box {

        .line {
            width: 100%;
            height: 2px;
            background-color: #E0E0E0;
            transform: translateY(15px);

            .progress {
                width: 0%;
                height: 100%;
                background-color: #FFC615;
                // animation: line-animate 6s ease-in 0s  1 forwards;
            }
        }

        .content {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .steps {
                position: relative;

                .num,
                .img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    border: 3px solid #E0E0E0;
                    text-align: center;
                    line-height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    color: #343434;
                    background-color: #fff;
                    overflow: hidden;

                    .done-icon {
                        display: block;
                        width: 12px;
                        height: auto;
                    }
                }

                .img {
                    width: 0;
                    height: 0;
                    border: 0px solid #FFC615;
                }

                .title-text {
                    position: absolute;
                    font-size: 13px;
                    color: #000000;
                    font-weight: 500;
                    left: 0;
                    bottom: -21px;
                    white-space: nowrap;
                    margin: 0;
                    transform: translate(-35%, 0);
                }
            }
        }


    }
}

.index-steps-animate {
    .aircraft-box {
        .aircraft-img {
            animation: aircraft-animate 6s ease-in 0s 1 forwards;
        }
    }

    .steps-box {

        .line {
            .progress {
                animation: line-animate 6s ease-in 0s 1 forwards;
            }
        }

        .content {
            .steps-active-0 {
                .num {
                    animation: step-animate-num-0 6s ease-in 0s 1 forwards;
                }

                .img {
                    animation: step-animate-img-0 6s ease-in 0s 1 forwards;
                }

                .title {
                    animation: step-animate-title-0 6s ease-in 0s 1 forwards;
                }
            }

            .steps-active-1 {
                .num {
                    animation: step-animate-num-1 6s ease-in 0s 1 forwards;
                }

                .img {
                    animation: step-animate-img-1 6s ease-in 0s 1 forwards;
                }

                .title {
                    animation: step-animate-title-1 6s ease-in 0s 1 forwards;
                }
            }

            .steps-active-2 {
                .num {
                    animation: step-animate-num-2 6s ease-in 0s 1 forwards;
                }

                .img {
                    animation: step-animate-img-2 6s ease-in 0s 1 forwards;
                }

                .title {
                    animation: step-animate-title-2 6s ease-in 0s 1 forwards;
                }
            }
        }


    }
}

@keyframes aircraft-box-animate {
    0% {
        transform: translateY(0px);
    }


    45% {
        transform: translateY(5px);
    }

    48% {
        transform: translateY(-5px);
    }

    50% {
        transform: translateY(5px);
    }

    52% {
        transform: translateY(-5px);
    }

    54% {
        transform: translateY(5px);
    }

    55% {
        transform: translateY(-5px);
    }

    51% {
        transform: translateY(0px);
    }



    90% {
        transform: translateY(5px);
    }

    92% {
        transform: translateY(-5px);
    }

    94% {
        transform: translateY(5px);
    }

    96% {
        transform: translateY(-5px);
    }

    98% {
        transform: translateY(5px);
    }

    100% {
        transform: translateY(-5px);
    }
}

@keyframes aircraft-animate {
    0% {
        left: 0;
    }

    45% {
        left: 50%;
    }

    55% {
        left: 50%;
    }

    90% {
        left: 100%;
    }

    100% {
        left: 100%;
    }
}

@keyframes line-animate {
    0% {
        width: 0;
    }

    45% {
        width: 50%
    }

    55% {
        width: 50%;
    }

    90% {
        width: 100%;
    }

    100% {
        width: 100%;
    }
}

@keyframes step-animate-num-0 {
    0% {
        width: 0;
        height: 0;
        border: 0;
    }

    100% {
        width: 0;
        height: 0;
        border: 0;
    }
}

@keyframes step-animate-img-0 {
    0% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    100% {
        width: 24px;
        height: 24px;
        border-width: 4px;
    }
}

@keyframes step-animate-title-0 {
    0% {
        color: #FFC615;
    }

    100% {
        color: #FFC615;
    }
}

@keyframes step-animate-num-1 {
    0% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    44.9% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    45% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    100% {
        width: 0;
        height: 0;
        border-width: 0;
    }
}

@keyframes step-animate-img-1 {
    0% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    44.9% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    45% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    100% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }
}

@keyframes step-animate-title-1 {
    0% {
        color: #000;
    }

    44.9% {
        color: #000;
    }

    45% {
        color: #FFC615;
    }

    100% {
        color: #FFC615;
    }

}

@keyframes step-animate-num-2 {
    0% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    89.9% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    90% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    100% {
        width: 0;
        height: 0;
        border-width: 0;
    }
}

@keyframes step-animate-img-2 {
    0% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    89.9% {
        width: 0;
        height: 0;
        border-width: 0;
    }

    90% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }

    100% {
        width: 24px;
        height: 24px;
        border-width: 3px;
    }
}

@keyframes step-animate-title-2 {

    0% {
        color: #000;
    }

    89.9% {
        color: #000;
    }

    90% {
        color: #FFC615;
    }

    100% {
        color: #FFC615;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/IndexSteps/index.vue